import { FC, useEffect, useState } from 'react'
import gclasses from '../../../../../CRMSettings/global.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import moment from 'moment'
import { LeadStatus } from '@/api/types/crm.types'
import { DeleteOutlined } from '@ant-design/icons'
import { useAddAlert } from '@/hooks/useAddAlert'
import Preloader from '@UI/Preloader'
import DeleteLeadStatusModal from '../../components/DeleteLeadStatusModal/DeleteLeadStatusModal'
import { formatDate, formatDateTime } from '../../../../utils/formatData'
import StatusItem from './StatusItem'
import { Empty } from 'antd'
import { useLeadStatuses } from './LeadStatusContext' // Import the context hook
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'

interface StatusListBlockProps {
  dateL?: string
  dateZ?: string
  leadId: number
}

const StatusListBlock: FC<StatusListBlockProps> = ({
  dateL,
  dateZ,
  leadId,
}) => {
  const addAlert = useAddAlert()
  const { statuses, loading, refreshStatuses } = useLeadStatuses()
  const { currentRole, ...access } = useFullLeadModalAccess()
  const [deleteModal, setDeleteModal] = useState<LeadStatus | null>(null)

  return (
    <div className={classes.statusListWrapper}>
      <div className={classes.statusListDateContainer}>
        {dateL && <p>Дата заявки: {formatDateTime(dateL)}</p>}
        {dateZ && <p>Дата взятия: {formatDateTime(dateZ)}</p>}
      </div>
      <div className={cn('custom-scroll', classes.statusListStatuses)}>
        {loading ? (
          <div
            className={classes.statusListItem}
            style={{ justifyContent: 'center' }}
          >
            <Preloader fullScreen="app" />
          </div>
        ) : statuses.length < 1 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={null}
            className={classes.emptyListItem}
          />
        ) : (
          statuses
            .sort(
              (a, b) =>
                moment(b.created_at).valueOf() - moment(a.created_at).valueOf(),
            )
            .map((item) => (
              <StatusItem
                key={item.id}
                leadStatus={item}
                onDelete={() => setDeleteModal(item)}
                isDeleteButton={access.canDeleteLeadStatus}
              />
            ))
        )}
      </div>

      <DeleteLeadStatusModal
        status={deleteModal}
        open={deleteModal !== null}
        onClose={() => setDeleteModal(null)}
        onSuccess={() => {
          refreshStatuses()
          setDeleteModal(null)
        }}
      />
    </div>
  )
}

export default StatusListBlock
